import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.812 2.233c-.522-.555-1.255-.067-2.722.91l-.846.562q-.975.645-1.945 1.297L3 5C.375 5 0 5.375 0 8s.375 3 3 3q.155 0 .3-.002.97.651 1.944 1.297l.002.001.844.561c1.467.977 2.2 1.465 2.722.91.521-.556.521-1.825.521-4.364V6.597c0-2.539 0-3.808-.521-4.364"
                fill="currentColor"
            />
            <path
                d="M12.515 8 11.01 9.505l.99.99 1.505-1.505 1.505 1.505.99-.99L14.495 8 16 6.495l-.99-.99-1.505 1.505L12 5.505l-.99.99z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeakerCrossFilledSize16Glyph.displayName = 'SpeakerCrossFilledSize16Glyph';
